import { render, staticRenderFns } from "./GithubProjects.vue?vue&type=template&id=01dbfc10&"
import script from "./GithubProjects.vue?vue&type=script&lang=js&"
export * from "./GithubProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports